import { DvColumnType, DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { Entity } from '@shared/constants/entity';
import { Coordinates } from '@features/map/interfaces';
import { ColDef } from 'ag-grid-community';
import { vtPresetActions } from '@features/vt-grid/presets/preset-actions';

@Injectable()
export class AssetsLogGridService {
  private toolbarActionService = inject(ToolbarActionsService);

  colDefs: ColDef[] = [
    {
      headerName: 'Asset.AssetID',
      field: 'AssetLogID',
      type: [ColumnType.Id],
      hide: true,
    },
    {
      field: 'UTCTime',
      headerName: 'Asset.DateAndTime',
      type: [DvColumnType.DateTime],
      enableRowGroup: false,
    },
    {
      headerName: 'Asset.Latitude',
      field: 'Latitude',
      type: [ColumnType.Number],
      enableRowGroup: false,
      flex: 1,
    },
    {
      headerName: 'Asset.Longitude',
      field: 'Longitude',
      type: [ColumnType.Number],
      enableRowGroup: false,
      flex: 1,
    },
  ];

  getGridActions(
    showOnMap: (coordinates: Coordinates, lastMoved: string) => void
  ): DvToolbarAction[] {
    return [
      vtPresetActions.reset,
      vtPresetActions.fit,
      vtPresetActions.reload,
      {
        ...vtPresetActions.excel,
        clickFn: event =>
          this.toolbarActionService.serverSideExcelExport(
            Entity.AssetLog,
            event.api,
            event.context
          ),
      },
      {},
      {
        icon: 'map_marker_move',
        tooltipKey: 'AssetsGrid.ShowAssetOnMap',
        clickFn: event => {
          const rowData = event.api.getSelectedRows()[0];
          showOnMap(
            {
              lat: rowData.Latitude,
              lng: rowData.Longitude,
            },
            rowData.UTCTime
          );
        },
        disabled: true,
      },
    ];
  }
}
